import styled from "styled-components";

type TextareaType = {
  disabled?: boolean;
  maxWidth?: number;
  resize?: boolean;
  height?: number;
};

export const StyledLabel = styled.label<TextareaType>`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  max-width: ${({ maxWidth }) => maxWidth && `${maxWidth}px`};
  color: ${({ disabled, theme }) => disabled && theme.colors.disabled};
  display: flex;
  font-size: 0.9em;
  height: 20px;
  font-weight: ${({ theme }) => theme.fontWeight.bolder};
`;

export const StyledTextarea = styled.textarea<TextareaType>`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  color: ${({ disabled, theme }) => disabled && theme.colors.disabled};
  cursor: ${({ disabled }) => disabled && "not-allowed"};
  display: flex;
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  width: calc(100% - 24px);
  resize: none;
  padding: 10px;
  position: relative;
  margin: 5px 0 15px 0;
  max-width: ${({ maxWidth }) => maxWidth && `${maxWidth}px`};
  resize: ${({ resize }) => (resize ? "vertical" : "none")};
  height: ${({ height }) => height && `${height}em`};

  &::placeholder {
    font-weight: ${({ theme }) => theme.fontWeight.light};
    color: ${({ disabled, theme }) => disabled && theme.colors.disabled};
  }

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(233 102 163 / 60%);
  }
`;

StyledTextarea.displayName = "StyledTextarea";

export const Required = styled.span<TextareaType>`
  &:after {
    content: "*";
    color: ${({ disabled, theme }) =>
      disabled ? theme.colors.disabled : theme.colors.primary};
    font-weight: 400;
    font-size: 1.5em;
    position: relative;
    top: -2px;
    left: 5px;
  }
`;
